/*  Loop Subscription Bundle Snippet v3.4

Created and maintained by LOOP SUBSCRIPTIONS (https://apps.shopify.com/loop-subscriptions)
DO NOT modify source code of this file because
- It is an automatically generated file from LOOP SUBSCRIPTIONS backend.
- LOOP SUBSCRIPTIONS will keep releasing new versions of this file. You can check the latest version
  available by visiting Loop Admin > Bundles > Snippets > Install bundle snippet.
- Updating will replace the existing file implying that all the custom code on the existing file
  (if any) will be lost.
- If you need to make changes, please do it using our standard bundle style settings available inside each bundle details page on Loop admin portal.
If you need any help, please contact us at support@loopwork.co.
*/

const BUNDLE_LINK_PREFIX = "/a/loop_subscriptions/bundle";
const LOOP_BUNDLE_URL = "https://api-service.loopwork.co/bundleTransaction/getBundleCartDetails";
const LOOP_API_SERVICE_URL = "https://api-service.loopwork.co";
let BUNDLE_CONTAINER_CLASS = "BUNDLE_CONTAINER_CLASS";
let CART_SUBTOTAL_CLASS = "CART_SUBTOTAL_CLASS";

//dev
// const LOOP_BUNDLE_URL =
//   "https://dev-api-service.loopwork.co/bundleTransaction/getBundleCartDetails";
// const LOOP_API_SERVICE_URL = "https://dev-api-service.loopwork.co";

//prod
// const LOOP_BUNDLE_URL =
//   "https://api-service.loopwork.co/bundleTransaction/getBundleCartDetails";
// const LOOP_API_SERVICE_URL = "https://api-service.loopwork.co";

const getItemsHtmlLoop = (item, bundleQuantityMapping) => {
    let quantity = item.quantity;
    if (bundleQuantityMapping) {
        let variant = bundleQuantityMapping.find(
            (v) => v.childProductId === item.id
        );
        if (variant) {
            quantity = variant.quantity;
        }
    }
    return `<p><span style="display:block;" class="data-cart-item-selling-plan-name">${
        item.title || ""
    } x ${quantity || ""}</span></p>`;
};

const getEditCartButton = (bundleTransactionId, editBtnText = "Edit") => {
    return `<button onclick="event.preventDefault(); changeBundleCartItems('${bundleTransactionId}');" style="background:none;border:none;display:flex;align-items:center;gap:3px;cursor:pointer;padding:0; text-decoration:underline;">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pen" viewBox="0 0 17 17">
            <path fill-rule="evenodd" d="M15.655 4.344a2.695 2.695 0 0 0-3.81 0l-.599.599-.009-.009-1.06 1.06.008.01-5.88 5.88a2.75 2.75 0 0 0-.805 1.944v1.922a.75.75 0 0 0 .75.75h1.922a2.75 2.75 0 0 0 1.944-.806l7.54-7.539a2.695 2.695 0 0 0 0-3.81Zm-4.409 2.72-5.88 5.88a1.25 1.25 0 0 0-.366.884v1.172h1.172c.331 0 .65-.132.883-.366l5.88-5.88-1.689-1.69Zm2.75.629.599-.599a1.195 1.195 0 1 0-1.69-1.689l-.598.599 1.69 1.689Z"></path>
        </svg>
        <p style="padding:0px;margin:0px;margin-top:5px">${
            editBtnText ?? "Edit"
        }</p>
    </button>`;
};

// const getBundleCartTableTemplateLoop = (bundleItem, index, bundleLink) => {
    
//     return `
//         <tr class="cart-item" id="CartBundleItem-${index}">
//     <td class="cart-item__media">
//         <a href="${bundleLink}" class="cart-item__link" aria-hidden="true" tabindex="-1"> </a>
//           <div class="cart-item__image-container gradient global-media-settings">
//             <img src="${
//                 bundleItem.image || ""
//             }"  class="cart-item__image" alt="" loading="lazy" width="150" height="94">
//           </div>
//     </td>

//     <td class="cart-item__details"><a href="" class="cart-item__name h4 break">${
//         bundleItem.label
//     }</a>
//                 <div class="product-option">
//             ${bundleItem.items.map((item) => getItemsHtmlLoop(item)).join("")}
//               <br/>
//         </div>
//         <div class="product-option">
//          ${bundleItem.price}
//         </div><dl></dl>
//         <p class="product-option">${
//             bundleItem.sellingPlan || ""
//         }</p><ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul>
//         ${getEditCartButton(bundleItem.bundleId, bundleItem.editBtnText)}
//     </td>

//     <td class="cart-item__totals right medium-hide large-up-hide">
//       <div class="cart-item__price-wrapper">
//         <span class="price price--end">
//              ${bundleItem.price}
//         </span>
//       </div>
//     </td>

//     <td class="cart-item__quantity">
//       <div class="cart-item__quantity-wrapper">
//         <quantity-input class="quantity">
//           <input disabled class="quantity__input" type="number" value="1" min="0">
//         </quantity-input>
//         <cart-remove-button>
//           <a onclick="removeBundleLoop('${
//               bundleItem.bundleId
//           }')" class="button button--tertiary" aria-label="${
//         bundleItem.label
//     }" style="cursor : pointer">
//             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" role="presentation" class="icon icon-remove">
//                 <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
//                 <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
//             </svg>
//           </a>
//         </cart-remove-button>
//       </div>
//     </td>

//     <td class="cart-item__totals right small-hide">
//       <div class="cart-item__price-wrapper"><span class="price price--end">
//            ${bundleItem.price}
//           </span></div>
//     </td>
//   </tr>
//     `;
// };

const getBundleCartTableTemplateLoop = (bundleItem, index, bundleLink) => {
    
    return `
        <tr class="cart-item border-t lg:gap-4 grid grid-cols-4 md:table-row auto-rows-auto relative" id="CartBundleItem-${index}">
                  <td class="md:w-1/12 pt-7 pb-0 md:pt-5 md:pb-5 col-start-1 col-end-1 align-top">
                    <div class="relative w-full md:w-32 float-left before:h-0 before:block before:pb-[100%]" bis_skin_checked="1">
                      <a href="${bundleLink}" class="absolute top-0 left-0 disable-effect w-full h-full overflow-hidden rounded-md" aria-label="Item added to your cart">
                          <img src="${bundleItem.image || ""}" class="object-cover h-full w-full top-0 left-0 absolute duration-300 image-hover z-0" alt="" loading="lazy" width="150" height="150">
                          
</a>
                    </div>
                  </td>
                  <td class="md:w-5/12 pt-7 pb-0 pl-5 pr-5 md:pt-5 md:pb-5 lg:pl-9 lg:pr-14 col-start-2 col-end-4 align-top"><div bis_skin_checked="1">
                      <a href="${bundleLink}" class="text-[rgba(var(--colors-heading))] table mb-3 disable-effect hover-text-link p-break-words">
                        ${bundleItem.label}
                      </a>

                      <div class="price mb-2 md:hidden" bis_skin_checked="1"><s class="cap mr-1 rtl:ml-1 rtl:mr-0 inline-block opacity-50"></s> 
                          <span class="selection:bg-text-[rgb(var(--colors-price-sale),0.2)] price-sale">
                            
                              ${bundleItem.price}
                            
                          </span></div>
                    </div>
                    <div class="product-option" bis_skin_checked="1">
                      ${bundleItem.items.map((item) => getItemsHtmlLoop(item)).join("")}
                      <br/>
                    </div>
                    <dl class="text-normal">

</dl>
                      <p class="text-normal mt-1">${bundleItem.sellingPlan || ""}</p><ul class="w-fit pl-2 pr-2 pt-2 pb-2 bg-[rgba(var(--colors-text),0.1)] mt-4 lg:mb-0 rounded-full"><li class="flex relative x-discount items-center gap-2">
                            <span class="w-4 h-4 min-w-4 min-h-4 "><svg class="" fill="currentColor" viewBox="0 0 14 14" role="img" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
    <path d="m 3.83096,4.235405 q 0,-0.33492 -0.23696,-0.57188 -0.23697,-0.23697 -0.57188,-0.23697 -0.33492,0 -0.57188,0.23697 -0.23697,0.23696 -0.23697,0.57188 0,0.33491 0.23697,0.57188 0.23696,0.23696 0.57188,0.23696 0.33491,0 0.57188,-0.23696 0.23696,-0.23697 0.23696,-0.57188 z m 6.7425,3.63981 q 0,0.33491 -0.23381,0.56872 l -3.10268,3.109 q -0.24645,0.23381 -0.57504,0.23381 -0.33492,0 -0.56872,-0.23381 L 1.575039,7.028455 Q 1.334913,6.794645 1.167457,6.390225 1,5.985795 1,5.650885 v -2.62875 q 0,-0.3286 0.240126,-0.56872 0.240127,-0.24013 0.568721,-0.24013 H 4.4376 q 0.33491,0 0.73934,0.16746 0.40442,0.16745 0.64454,0.40758 l 4.51817,4.51185 q 0.23381,0.24644 0.23381,0.57504 z m 2.42654,0 q 0,0.33491 -0.23381,0.56872 l -3.10268,3.109 q -0.24645,0.23381 -0.57504,0.23381 -0.22749,0 -0.37283,-0.0885 -0.14534,-0.0885 -0.33491,-0.28436 l 2.96998,-2.96998 q 0.23381,-0.23381 0.23381,-0.56872 0,-0.3286 -0.23381,-0.57504 L 6.83254,2.788295 Q 6.59242,2.548165 6.18799,2.380715 5.78357,2.213255 5.44866,2.213255 h 1.41548 q 0.33491,0 0.73934,0.16746 0.40442,0.16745 0.64455,0.40758 l 4.51816,4.51185 Q 13,7.546615 13,7.875215 z"></path>
  </svg>
</span>
                            <span class="leading-none text-normal discount-title">bundle discount</span>
                            
                          </li></ul>
                    ${getEditCartButton(bundleItem.bundleId, bundleItem.editBtnText)}
                    <div id="LineItemError-${bundleItem.bundleId}" class="hidden bg-[rgba(var(--color-error),0.2)] cart-item__error mt-2 pt-3 pb-3 pr-3.5 pl-3.5 rounded-md" role="alert" bis_skin_checked="1">
                      <p class="flex relative w-full">
                        <span class="absolute left-0 rtl:left-auto rtl:right-0 top-1/2 -translate-y-1/2 w-3"><svg class="text-[rgba(var(--color-error))]" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 800 800" enable-background="new 0 0 800 800" xml:space="preserve" fill="currentColor">
    <path d="M400 0C179.1 0 0 179.1 0 400c0 220.9 179.1 400 400 400s400-179.1 400-400C800 179.1 620.9 0 400 0zm0 655.333c-31.267 0-52.667-24.1-52.667-55.333 0-32.134 22.3-55.333 52.667-55.333 32.1 0 52.667 23.199 52.667 55.333 0 31.267-20.567 55.333-52.667 55.333zm20.733-211.3c-7.967 27.167-33.066 27.634-41.434 0-9.633-31.866-43.866-152.833-43.866-231.4 0-103.667 129.699-104.167 129.699 0 0 79.034-36.099 203.134-44.399 231.4z"></path>
  </svg>
</span>
                        <span class="cart-item__error-text text-normal pl-6 rtl:pl-0 rtl:pr-6"></span>
                      </p>
                    </div>
                  </td>
                  <td class="pt-7 pb-0 md:pt-5 md:pb-5 hidden md:table-cell md:align-top md:w-2/12 pr-5">
                    <div class="price" bis_skin_checked="1">
                      <span><s class="cap mr-1 rtl:ml-1 rtl:mr-0 inline-block opacity-50"></s> 
                          <span class="selection:bg-text-[rgb(var(--colors-price-sale),0.2)] price-sale">
                            
                              ${bundleItem.price}
                            
                          </span></span></div>
                  </td>
                  <td class="lg:pl-2 pt-7 pb-0 md:pt-5 md:pb-5 md:hidden text-right md:text-left">
                    <div class="price" bis_skin_checked="1">
                      <span class="flex flex-wrap justify-end gap-1">
<s class="cap opacity-50">
                            

                          </s> 
                          <span class="selection:bg-text-[rgb(var(--colors-price-sale),0.2)] price-sale">
                            
                              ${bundleItem.price}
                            
                          </span></span></div>
                  </td>
                  
                  <td class="lg:pl-2 pt-0 pb-5 pl-5 mt-2 md:pr-5 lg:pr-0 md:mt-3.5 md:pl-0 md:pt-5 rtl:pr-5 rtl:md:pr-0 rtl:md:pl-5 rtl:lg:pl-0 col-start-2 col-end-4 flex items-center md:table-cell md:align-top">
                    <div class="x-cart-item-quantity flex" bis_skin_checked="1">
                      <div class="relative flex w-28 h-10 border border-solid justify-between rounded-md" bis_skin_checked="1">
                        <button class="items-center w-1/3 justify-center flex opacity-70 cursor-pointer" aria-label="button-minus" disabled>
                          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class=" w-3" viewBox="0 0 10 2">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor" stroke="currentColor" stroke-width="0" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg>

                        </button>
                        <input id="cart-qty-${bundleItem.bundleId}" class="cart-item-qty-${index} outer-spin-button bg-transparent w-1/3 text-center pt-2 pb-2 placeholder:opacity-60 focus-within:outline-none" aria-label="Quantity for ${bundleItem.label}" type="number" value="1" min="0" disabled>
                        <button class="items-center w-1/3 justify-center flex opacity-70 cursor-pointer" aria-label="button-plus" disabled>
                          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class=" w-3" viewBox="0 0 10 10">
    <path fill="currentColor" stroke="currentColor" stroke-width="0" stroke-linecap="round" stroke-linejoin="round" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z"></path>
  </svg>

                        </button>
                      </div>
                    </div>
                  </td>
                  <td class="pb-5 md:pt-5 md:table-cell md:align-top lg:w-2/12 lg:pl-2">
                    <div class="flex justify-end md:justify-between" bis_skin_checked="1">
                      <div class="price cart-item-price-${index} hidden md:flex md:flex-wrap" bis_skin_checked="1">
<s class="cap mr-1 rtl:ml-1 rtl:mr-0 inline-block opacity-50"></s> 
                          <span class="selection:bg-text-[rgb(var(--colors-price-sale),0.2)] price-sale">${bundleItem.price}
                            
                          </span></div>
                      
                        <button type="button" id="remove-${bundleItem.bundleId}" class="opacity-50 md:-mt-3.5 w-12 pt-3 pb-3 pl-3.5 pr-3.5 justify-center items-center cursor-pointer min-w-[3rem] flex" onclick="removeBundleLoop(event, '${bundleItem.bundleId}')" aria-label="button-remove" style="cursor: pointer; color: #323232;">
                          <span class="inline-block w-[18px] h-[18px]"><svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.7276 6.54541L13.0954 15.8287C12.9578 16.6112 12.2782 17.1818 11.4838 17.1818H4.8806C4.08618 17.1818 3.40653 16.6112 3.26896 15.8287L1.63672 6.54541" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M15.5456 4.09109H10.9434M10.9434 4.09109V2.45472C10.9434 1.55098 10.2108 0.818359 9.307 0.818359H7.057C6.15326 0.818359 5.42063 1.55098 5.42063 2.45472V4.09109M10.9434 4.09109H5.42063M0.818359 4.09109H5.42063" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg>
</span>
                        </button>
                      
                      <div id="loading-${bundleItem.bundleId}" class="md:-mt-3.5 w-12 hidden pt-3 pb-3 pl-3.5 pr-3.5 flex justify-center items-center cursor-pointer z-20" bis_skin_checked="1">
                        <div class="w-[18px] h-[18px] inline-block" bis_skin_checked="1">
                          <svg class="animate-spin rounded-full" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
    <path transform="translate(0 512) scale(0.1 -0.1)" fill="currentColor" d="M2474 4676 c-43 -19 -101 -81 -115 -123 -18 -56 -7 -145 24 -190 52 -75 79 -85 262 -99 90 -7 207 -22 260 -33 436 -92 824 -352 1070 -721 521 -781 321 -1824 -453 -2358 -501 -345 -1172 -393 -1715 -121 -700 350 -1075 1118 -917 1876 37 180 86 305 209 536 51 96 54 147 15 226 -37 73 -86 104 -174 109 -105 6 -151 -24 -224 -145 -137 -230 -241 -543 -276 -833 -13 -110 -13 -355 1 -478 52 -475 268 -922 614 -1267 351 -352 787 -560 1284 -615 171 -19 442 -8 615 24 423 80 802 282 1111 591 407 407 625 931 625 1505 0 574 -218 1098 -625 1505 -296 296 -654 493 -1055 579 -210 45 -470 61 -536 32z"></path>
  </svg>

                        </div>
                      </div>
                    </div>
                  </td> 
                </tr>
    `;
};
// const getBundleCartDrawerTemplateLoop = (bundleItem, index, bundleLink) => {
//     return `
//         <tr class="cart-item" id="CartBundleItem-${index}">
//           <td class="cart-item__media" style="text-align:center;">
//             <img class="cart-item__image"
//               src="${bundleItem.image || ""}"
//               alt="${bundleItem.label}" loading="lazy" width="75" height="75">
//           </td>
//           <td class="cart-item__details">
//             <a href="${bundleLink}"
//               class="cart-item__name break">
//               ${bundleItem.label || ""}
//             </a>
//             <dl>
//               <div class="product-option">
//                 ${bundleItem.items
//                     .map((item) => getItemsHtmlLoop(item))
//                     .join("")}
//                   <br/>
//                   <p><span class="data-cart-item-selling-plan-name">
//                     ${bundleItem.sellingPlan || ""}
//                   </span></p>
//               </div>
//             </dl>
//           </td>
//           <td class="cart-item__quantity small-hide">
//             ${bundleItem.quantity}
//           </td>
//           <td class="right medium-hide large-up-hide">
//             <div class="cart-item__price-wrapper medium-up" style="display: flex; gap: 10px;">
//               ${
//                   bundleItem.priceWithoutDiscount !== bundleItem.price
//                       ? `<span class="price price--end" style="text-decoration:line-through;">
//                     ${bundleItem.priceWithoutDiscount}
//                 </span>`
//                       : ""
//               }
//               <span class="price price--end" style="font-weight: 600;">
//                 ${bundleItem.price}
//               </span>
//             </div>
//             ${getEditCartButton(bundleItem.bundleId, bundleItem.editBtnText)}
//             <div onclick="removeBundleLoop('${
//                 bundleItem.bundleId
//             }')" style="cursor:pointer; width: fit-content;height: 15px;display: inline-flex;flex-direction: row-reverse;">
//               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style="width: 1em; height: 1em;" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">
//                     <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
//                     <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
//               </svg>
//             </div>
//           </td>
//         </tr>
//     `;
// };
const getBundleCartDrawerTemplateLoop = (bundleItem, index, bundleLink) => {
    return `
        <tr class="flex flex-col-reverse relative pt-3 pb-3 lg:pt-4 lg:pb-4 cart-item" role="row" id="CartBundleItem-${index}">
            <td class="flex relative duration-300">
                <div class="w-24 relative" role="cell">
                    <a href="${bundleLink}" class="block disable-effect w-full">
                        <div class="relative w-full overflow-hidden float-left before:h-0 before:block before:pb-[100%] rounded-md">
                            <img
                                class="absolute top-0 right-0 left-0 bottom-0 object-cover h-full w-full image-hover"
                                src="${bundleItem.image || ''}"
                                alt="${bundleItem.label || ''}"
                                loading="lazy"
                                width="150"
                                height="150"
                            >
                        </div>
                    </a>
                </div>
                <div class="pr-4 pl-4 flex flex-1 lg:pr-0" role="cell">
                    <div class="product-info-column-1 flex-1">
                        <div>
                            <a href="${bundleLink}" class="text-[rgba(var(--colors-heading))] mr-0 duration-200 transition disable-effect hover-text-link p-break-words">
                                ${bundleItem.label || ''}
                            </a>
                        </div>
                        <div class="price mt-2 mb-2 block lg:hidden">
                            ${bundleItem.priceWithoutDiscount && bundleItem.priceWithoutDiscount !== bundleItem.price
                                ? `<s class="cap mr-1 rtl:ml-1 rtl:mr-0 inline-block opacity-70">${bundleItem.priceWithoutDiscount}</s>
                                   <span class="selection:bg-text-[rgb(var(--colors-price-sale),0.2)] price-sale">${bundleItem.price}</span>`
                                : `<span>${bundleItem.price}</span>`
                            }
                        </div>
                        <dl>
                            <div class="product-option flex flex-col gap-1 mt-1 text-normal">
                                ${bundleItem.items.map((item) => getItemsHtmlLoop(item)).join('')}
                            </div>
                        </dl>
                        <p class="text-normal opacity-70 mt-1">${bundleItem.sellingPlan || ''}</p>
                        <ul class="w-full md:w-fit discounts flex flex-wrap gap-1 mt-2" role="list" aria-label="Discount">
                            <li class="inline-flex max-w-full items-center rounded overflow-hidden relative x-discount bg-[rgba(var(--colors-text),0.1)] pr-2 pl-2 pb-1 pt-1">
                                <div class="w-fit mr-1">
                                    <span class="w-3 h-3 block">
                                        <svg fill="currentColor" viewBox="0 0 14 14" role="img" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                                            <path d="m 3.83096,4.235405 q 0,-0.33492 -0.23696,-0.57188 -0.23697,-0.23697 -0.57188,-0.23697 -0.33492,0 -0.57188,0.23697 -0.23697,0.23696 -0.23697,0.57188 0,0.33491 0.23697,0.57188 0.23696,0.23696 0.57188,0.23696 0.33491,0 0.57188,-0.23696 0.23696,-0.23697 0.23696,-0.57188 z m 6.7425,3.63981 q 0,0.33491 -0.23381,0.56872 l -3.10268,3.109 q -0.24645,0.23381 -0.57504,0.23381 -0.33492,0 -0.56872,-0.23381 L 1.575039,7.028455 Q 1.334913,6.794645 1.167457,6.390225 1,5.985795 1,5.650885 v -2.62875 q 0,-0.3286 0.240126,-0.56872 0.240127,-0.24013 0.568721,-0.24013 H 4.4376 q 0.33491,0 0.73934,0.16746 0.40442,0.16745 0.64454,0.40758 l 4.51817,4.51185 q 0.23381,0.24644 0.23381,0.57504 z m 2.42654,0 q 0,0.33491 -0.23381,0.56872 l -3.10268,3.109 q -0.24645,0.23381 -0.57504,0.23381 -0.22749,0 -0.37283,-0.0885 -0.14534,-0.0885 -0.33491,-0.28436 l 2.96998,-2.96998 q 0.23381,-0.23381 0.23381,-0.56872 0,-0.3286 -0.23381,-0.57504 L 6.83254,2.788295 Q 6.59242,2.548165 6.18799,2.380715 5.78357,2.213255 5.44866,2.213255 h 1.41548 q 0.33491,0 0.73934,0.16746 0.40442,0.16745 0.64455,0.40758 l 4.51816,4.51185 Q 13,7.546615 13,7.875215 z"></path>
                                        </svg>
                                    </span>
                                </div>
                                <span class="leading-none text-normal discount-title line-clamp-1 md:line-clamp-none">bundle discount</span>
                            </li>
                        </ul>
                        ${getEditCartButton(bundleItem.bundleId, bundleItem.editBtnText)}
                        <div id="LineItemError-${bundleItem.bundleId}" class="hidden bg-[rgba(var(--color-error),0.2)] cart-item__error mt-2 pt-3 pb-3 pl-3.5 pr-3.5 mb-3 rounded-md" role="alert">
                            <p class="flex relative w-full">
                                <span class="absolute left-0 top-1/2 -translate-y-1/2 w-3">
                                    <svg class="text-[rgba(var(--color-error))]" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800" fill="currentColor">
                                        <path d="M400 0C179.1 0 0 179.1 0 400c0 220.9 179.1 400 400 400s400-179.1 400-400C800 179.1 620.9 0 400 0zm0 655.333c-31.267 0-52.667-24.1-52.667-55.333 0-32.134 22.3-55.333 52.667-55.333 32.1 0 52.667 23.199 52.667 55.333 0 31.267-20.567 55.333-52.667 55.333zm20.733-211.3c-7.967 27.167-33.066 27.634-41.434 0-9.633-31.866-43.866-152.833-43.866-231.4 0-103.667 129.699-104.167 129.699 0 0 79.034-36.099 203.134-44.399 231.4z"></path>
                                    </svg>
                                </span>
                                <span class="cart-item__error-text text-small pl-5 p-break-words"></span>
                            </p>
                        </div>
                    </div>

                    <div class="product-info-column-2 max-w-[40%] md:max-w-full flex-1 flex flex-col items-end">
                        <div class="price hidden lg:block mb-2">
                            ${bundleItem.priceWithoutDiscount && bundleItem.priceWithoutDiscount !== bundleItem.price
                                ? `<s class="cap mr-1 rtl:ml-1 rtl:mr-0 inline-block opacity-70">${bundleItem.priceWithoutDiscount}</s>
                                   <span class="selection:bg-text-[rgb(var(--colors-price-sale),0.2)] price-sale">${bundleItem.price}</span>`
                                : `<span>${bundleItem.price}</span>`
                            }
                        </div>
                        <div class="cart-item__quantity" role="cell">
                            <div class="flex items-center flex-col-reverse">
                                <button class="flex pt-3 pb-1 pr-3 pl-3 text-normal cursor-pointer underline z-50"
                                    onclick="removeBundleLoop(event, '${bundleItem.bundleId}')"
                                    aria-label="button-remove"
                                >
                                    Remove
                                </button>
                                <div class="relative flex w-[72px] h-9 lg:w-28 lg:h-10 border border-solid justify-between !rounded-md">
                                    <button class="items-center w-1/3 justify-center flex no-js-hidden opacity-70 cursor-pointer" aria-label="button-minus" disabled>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="w-3" viewBox="0 0 10 2">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor" stroke="currentColor"></path>
                                        </svg>
                                    </button>
                                    <input
                                        id="cart-qty-bundle-drawer-${bundleItem.bundleId}"
                                        class="cart-qty cart-item-qty-${index} outer-spin-button w-1/3 bg-transparent text-center pt-2.5 pb-2.5 placeholder:opacity-60 focus-within:outline-none"
                                        aria-label="Quantity for ${bundleItem.label}"
                                        type="number"
                                        value="1"
                                        min="0"
                                        disabled
                                    >
                                    <button class="items-center w-1/3 justify-center flex opacity-70 cursor-pointer" aria-label="button-plus" disabled>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="w-3" viewBox="0 0 10 10">
                                            <path fill="currentColor" stroke="currentColor" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z"></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="loading-bundle-drawer-${bundleItem.bundleId}" class="absolute hidden top-0 bottom-0 h-full w-full">
                    <div class="absolute top-0 right-0 w-full h-full opacity-20 bg-black"></div>
                    <div class="loading-cover">
                        <span class="loading-bar absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"></span>
                    </div>
                </div>
            </td>
        </tr>
    `;
};
const getBundleCartItemsDivTemplateLoop = (bundleItem, index, bundleLink) => {
     
    return `
        <div style="display:flex; gap:20px; justify-content: space-between;" id="CartBundleItem-${index}">
          <div style="display:flex; gap:20px;">
            <div style="text-align:center;">
              <img
                src="${bundleItem.image || ""}"
                alt="${bundleItem.label}" loading="lazy" width="75" height="75">
            </div>
            <div>
              <a href="${bundleLink}"
                 style="font-weight:600">
                ${bundleItem.label || ""}
              </a>
              <div>
                ${bundleItem.items
                    .map((item) => getItemsHtmlLoop(item))
                    .join("")}
                  <br/>
                  <p><span>${bundleItem.sellingPlan || ""}</span></p>
              </div>
            </div>
          </div>
          <div>
            ${bundleItem.quantity}
          </div>
          <div>
            <div style="display: flex; gap: 10px;">
                ${
                    bundleItem.priceWithoutDiscount !== bundleItem.price
                        ? `<span style="text-decoration:line-through;">
                        ${bundleItem.priceWithoutDiscount}
                    </span>`
                        : ""
                }
              <span style="font-weight: 600;">${bundleItem.price}</span>
            </div>
            ${getEditCartButton(bundleItem.bundleId, bundleItem.editBtnText)}
            <div onclick="removeBundleLoop(event, '${
                bundleItem.bundleId
            }')" style="cursor:pointer; vertical-align: text-top; width: fit-content;height: 15px;display: inline-flex;flex-direction: row-reverse;">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style="width: 1em; height: 1em;" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">
                    <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                    <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
              </svg>
            </div>
          </div>
        </div>
    `;
};

const getPresetBundleCartTemplateLoop = (bundleItem, index, bundleLink) => {
    const priceMarkup =
        bundleItem.priceWithoutDiscount &&
        bundleItem.priceWithoutDiscount !== bundleItem.price
            ? `<s class="cap mr-1 rtl:ml-1 rtl:mr-0 inline-block opacity-70">${bundleItem.priceWithoutDiscount}</s><span class="price price--end selection:bg-text-[rgb(var(--colors-price-sale),0.2)] price-sale">${bundleItem.price}</span>`
            : `<span class="price price--end">${bundleItem.price}</span>`;

    return `
        <tr class="cart-item" id="CartBundleItem-${index}">
    <td class="cart-item__media">
        <a href="${bundleLink}" class="cart-item__link" aria-hidden="true" tabindex="-1"> </a>
          <div class="cart-item__image-container gradient global-media-settings">
            <img src="${
                bundleItem.image || ""
            }"  class="cart-item__image" alt="" loading="lazy" width="150" height="94">
          </div>
    </td>

    <td class="cart-item__details"><a href="${bundleLink}" class="cart-item__name h4 break">${
        bundleItem.label
    }</a>
        <div class="product-option">
            ${bundleItem.items
                .map((item) =>
                    getItemsHtmlLoop(item, bundleItem.bundleQuantityMapping)
                )
                .join("")}
              <br/>
        </div>
        <div class="product-option">
         ${bundleItem.eachBundleAmount}
        </div><dl></dl>

        <p class="product-option">${bundleItem.sellingPlan || ""}</p>
        ${
            bundleItem.discountTitle
                ? `<ul class="discounts list-unstyled" role="list" aria-label="Discount">
            <li class="discounts__discount">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-text" viewBox="0 0 12 12">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor">
                    </path>
                </svg>
                ${bundleItem.discountTitle}
            </li>
        </ul>`
                : ""
        }
    </td>

    <td class="cart-item__totals right medium-hide large-up-hide">
      <div class="cart-item__price-wrapper">${priceMarkup}</div>
    </td>

    <td class="cart-item__quantity">
      <div class="cart-item__quantity-wrapper">
        <quantity-input class="quantity">
          <input disabled class="quantity__input" type="number" value="${
              bundleItem.bundleProductQuantity
          }" min="0">
        </quantity-input>
        <cart-remove-button>
          <a onclick="removeBundleLoop(event, '${
              bundleItem.bundleId
          }')" class="button button--tertiary" aria-label="${
        bundleItem.label
    }" style="cursor : pointer">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" role="presentation" class="icon icon-remove">
                <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
            </svg>
          </a>
        </cart-remove-button>
      </div>
    </td>

    <td class="cart-item__totals right small-hide">
      <div class="cart-item__price-wrapper">${priceMarkup}</div>
    </td>
  </tr>
    `;
};

const getPresetBundleCartDrawerTemplateLoop = (
    bundleItem,
    index,
    bundleLink
) => {
     
    const priceMarkup =
        bundleItem.priceWithoutDiscount &&
        bundleItem.priceWithoutDiscount !== bundleItem.price
            ? `<s class="cap mr-1 rtl:ml-1 rtl:mr-0 inline-block opacity-70">${bundleItem.priceWithoutDiscount}</s><span class="price price--end selection:bg-text-[rgb(var(--colors-price-sale),0.2)] price-sale">${bundleItem.price}</span>`
            : `<span class="price price--end">${bundleItem.price}</span>`;

    return `
        <tr class="cart-item" id="CartBundleItem-${index}">
    <td class="cart-item__media">
        <a href="${bundleLink}" class="cart-item__link" aria-hidden="true" tabindex="-1"> </a>
          <div class="cart-item__image-container gradient global-media-settings">
            <img src="${
                bundleItem.image || ""
            }"  class="cart-item__image" alt="" loading="lazy" width="150" height="94">
          </div>
    </td>

    <td class="cart-item__details"><a href="${bundleLink}" class="cart-item__name h4 break">${
        bundleItem.label
    }</a>
                <div class="product-option">
            ${bundleItem.items
                .map((item) =>
                    getItemsHtmlLoop(item, bundleItem.bundleQuantityMapping)
                )
                .join("")}
              <br/>
        </div>
        <div class="product-option">
         ${bundleItem.eachBundleAmount}
        </div><dl></dl>

        <p class="product-option">${bundleItem.sellingPlan || ""}</p>
        ${
            bundleItem.discountTitle
                ? `<ul class="discounts list-unstyled" role="list" aria-label="Discount">
            <li class="discounts__discount">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-text" viewBox="0 0 12 12">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor">
                    </path>
                </svg>
                ${bundleItem.discountTitle}
            </li>
        </ul>`
                : ""
        }
    </td>

    <td class="cart-item__totals right medium-hide large-up-hide">
      <div class="cart-item__price-wrapper">${priceMarkup}</div>
    </td>

    <td class="cart-item__quantity">
      <div class="cart-item__quantity-wrapper">
        <quantity-input class="quantity">
          <input disabled class="quantity__input" type="number" value="${
              bundleItem.bundleProductQuantity
          }" min="0">
        </quantity-input>
        <cart-remove-button>
          <a onclick="removeBundleLoop(event, '${
              bundleItem.bundleId
          }')" class="button button--tertiary" aria-label="${
        bundleItem.label
    }" style="cursor : pointer">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" role="presentation" class="icon icon-remove">
                <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
            </svg>
          </a>
        </cart-remove-button>
      </div>
    </td>

    <td class="cart-item__totals right small-hide">
      <div class="cart-item__price-wrapper">${priceMarkup}</div>
    </td>
  </tr>
    `;
};

// returns cart item key of a bundleId
const getItemKeysByBundleIdLoop = (bundleId) => {
    const cartItems = window.Loop.bundleCartAllItems;
    const data = {
        updates: {},
    };
    for (const item of cartItems) {
        const _bundleId =
            item?.properties?._bundleId ?? item?.properties?.bundleId;
        if (!_bundleId || _bundleId !== bundleId) continue;
        data.updates[item.key] = 0;
    }
    return data;
};

// removes a bundleId from cart
const removeBundleLoop = async (event, bundleId) => {
    const trigger = event && event.currentTarget ? event.currentTarget : null;
    const isDrawerRemove = Boolean(
        trigger &&
            trigger.closest &&
            trigger.closest(".LOOP_fr-hellodarknessmyoldfriend_bundles_drawer")
    );

    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }
    const data = getItemKeysByBundleIdLoop(bundleId);
    const endpoint = `${window.Shopify.routes.root}cart/update.js`;
    const cartHelper =
        window.Alpine && window.Alpine.store
            ? window.Alpine.store("xCartHelper")
            : null;
    const miniCart =
        window.Alpine && window.Alpine.store
            ? window.Alpine.store("xMiniCart")
            : null;

    const requestData = { ...data };
    if (cartHelper && typeof cartHelper.getSectionsToRender === "function") {
        requestData.sections = cartHelper.getSectionsToRender().map(
            (section) => section.id
        );
        requestData.sections_url = window.location.pathname;
    }

    if (cartHelper && typeof cartHelper.waitForCartUpdate === "function") {
        await cartHelper.waitForCartUpdate();
    }

    window.updatingCart = true;

    try {
        const response = await fetch(endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });
        const parsedState = await response.json();

        if (!response.ok || parsedState.status === 422) {
            throw new Error(
                parsedState.description ||
                    parsedState.message ||
                    "Unable to remove bundle from cart."
            );
        }

        window.Loop = window.Loop || {};
        window.Loop.bundleCartAllItems = parsedState.items || [];

        if (cartHelper && parsedState.sections) {
            cartHelper.reRenderSections(parsedState.sections);
            const bubble = document.getElementById("cart-icon-bubble");
            if (bubble) {
                cartHelper.currentItemCount = parseInt(bubble.innerHTML, 10);
            }
        } else if (miniCart && typeof miniCart.reLoad === "function") {
            miniCart.reLoad();
        }

        if (!isDrawerRemove) {
            window.location.reload();
            return;
        }

        document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
        document.dispatchEvent(new CustomEvent("eurus:cart-drawer:rerender"));
        document.dispatchEvent(new CustomEvent("cart:updated"));
    } catch (error) {
        console.error("Loop bundle remove failed:", error);
        if (miniCart && typeof miniCart.reLoad === "function") {
            miniCart.reLoad();
        } else {
            window.location.reload();
        }
    } finally {
        window.updatingCart = false;
    }
};

const changeBundleCartItems = async (bundleTransactionId) => {
    disableEditButton();
    const currentLocale = window?.Shopify?.locale;
    const root = window?.Shopify?.routes?.root ?? "/";

    if (bundleTransactionId) {
        const _editBundleRef = `${BUNDLE_LINK_PREFIX}/change/${bundleTransactionId}`;
        if (currentLocale && root !== "/") {
            window.location.href = `/${currentLocale}${_editBundleRef}`;
        } else {
            window.location.href = _editBundleRef;
        }
    }
};

const disableEditButton = (bundleId) => {
    console.log(`disabling bundle edit button: ${bundleId}`);
    const editButttons = document.querySelectorAll(
        `loop-edit-bundle-${bundleId}`
    );
    for (const button of editButttons) {
        button.disabled = true;
    }
};

const fetchLoopBundleTransactionCartDetails = async (loopBundleGuid) => {
    const { locale } = window.Shopify;
    const _locale = locale.split("-")[0];
    const _endpoint = `${LOOP_BUNDLE_URL}/${loopBundleGuid}?locale=${_locale}`;
    const _response = await fetch(_endpoint);
    return await _response.json();
};

// Helper function to format price using Intl
const formatPrice = (amount, currencyCode = null) => {
    const currency = currencyCode || window?.Shopify?.currency?.active || "USD";
    const locale = window?.Shopify?.locale || "en";

    try {
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(amount);
    } catch (error) {
        // Fallback if Intl fails
        console.error("Error formatting price:", error);
        return `${currency} ${amount.toFixed(2)}`;
    }
};

const addExtraDetailsToBundleItemsLoop = async (bundleItems) => {
    let totalDiscount = 0;
    let currencyCode = "";

    // Get the exchange rate for currency conversion (default to 1 if not available)
    const exchangeRate = window?.Shopify?.currency?.rate || 1;

    // Get active currency code
    currencyCode = window?.Shopify?.currency?.active;

    const fetchDetailsPromises = bundleItems.map((bundleItem) =>
        fetchLoopBundleTransactionCartDetails(bundleItem.bundleId)
    );
    const allExtraDetails = await Promise.all(fetchDetailsPromises);
    for (let i = 0; i < allExtraDetails.length; ++i) {
        const extraDetails = allExtraDetails[i];
        const bundleItem = bundleItems[i];
        const quantityMapping =
            extraDetails?.variantMap?.[bundleItem.bundleId] ?? [];
        const isPresetBundleProduct = bundleItem.isPresetBundleProduct;
        const totalBundleItemsQuantity = bundleItem.items.reduce(
            (acc, item) => acc + item.quantity,
            0
        );
        let price = isPresetBundleProduct
            ? bundleItem.discounted_price
            : bundleItem.price;

        bundleItem.label = extraDetails?.label;
        bundleItem.image = extraDetails?.image;
        bundleItem.sellingPlan = extraDetails?.name;
        bundleItem.editBtnText = extraDetails.editBtnText ?? "Edit";
        bundleItem.priceWithoutDiscount = formatPrice(price, currencyCode);
        bundleItem.final_line_price_currency = formatPrice(
            parseFloat(bundleItem.final_line_price),
            currencyCode
        );
        bundleItem.loopBundleId = extraDetails.loopBundleId;

        if (
            extraDetails.discountType &&
            extraDetails.discountValue &&
            !isPresetBundleProduct
        ) {
            if (extraDetails.discountType === "PERCENTAGE") {
                if (extraDetails.appliesOnEachItem) {
                    // if discount in each item
                    totalDiscount +=
                        price *
                        (parseFloat(extraDetails.discountValue) / 100) *
                        totalBundleItemsQuantity;
                    price =
                        price -
                        price *
                            (parseFloat(extraDetails.discountValue) / 100) *
                            totalBundleItemsQuantity;
                } else {
                    totalDiscount +=
                        price * (parseFloat(extraDetails.discountValue) / 100);
                    price =
                        price -
                        price * (parseFloat(extraDetails.discountValue) / 100);
                }
            } else {
                // Fixed amount discount - convert from store currency to customer's currency
                const convertedDiscountValue =
                    parseFloat(extraDetails.discountValue) * exchangeRate;

                if (extraDetails.appliesOnEachItem) {
                    // if discount in each item
                    totalDiscount +=
                        convertedDiscountValue * totalBundleItemsQuantity;
                    price =
                        price -
                        convertedDiscountValue * totalBundleItemsQuantity;
                } else {
                    totalDiscount += convertedDiscountValue;
                    price = price - convertedDiscountValue;
                }
            }
        }

        bundleItem.price = formatPrice(parseFloat(price), currencyCode);

        if (extraDetails?.productsQuantity) {
            bundleItems[i]["bundleProductQuantity"] =
                extraDetails.productsQuantity;
            bundleItems[i]["eachBundleAmount"] = formatPrice(
                parseFloat(
                    bundleItems[i].final_line_price /
                        extraDetails.productsQuantity
                ),
                currencyCode
            );
        } else {
            bundleItems[i]["bundleProductQuantity"] = 1;
            bundleItems[i]["eachBundleAmount"] = formatPrice(
                parseFloat(price / 1),
                currencyCode
            );
        }
        if (quantityMapping.length) {
            bundleItem.bundleQuantityMapping = quantityMapping;
        }
        if (isPresetBundleProduct) {
            bundleItem.productHandle = extraDetails.product_handle;
        }
    }

    removeDiscountFromSubtotalInCartLoop(totalDiscount, currencyCode);
};

const removeDiscountFromSubtotalInCartLoop = (totalDiscount, currencyCode) => {
    let targetNode = null;
    targetNode = document.querySelector(`.totals__subtotal-value`);
    if (targetNode) {
        applyDiscountByCartLineItemsLoop(
            targetNode,
            totalDiscount,
            currencyCode
        );
    }
};

function applyDiscountByCartLineItemsLoop(element, discount, currencyCode) {
    const totalLineItemsPrice = window.Loop.bundleCartAllItems.reduce(
        (acc, item) => {
            return (
                acc +
                (item.properties._isPresetBundleProduct
                    ? item.discounted_price
                    : item.price) *
                    item.quantity
            );
        },
        0
    );
    const discountedPrice = (
        (totalLineItemsPrice / 100).toFixed(2) - discount
    ).toFixed(2);

    if (!isNaN(discountedPrice)) {
        element.innerHTML = formatPrice(
            parseFloat(discountedPrice),
            currencyCode
        );
    }
}

const getBundleItemsLoop = (items) => {
    const bundleItemsMap = {};
    for (const item of items) {
        const bundleId =
            item?.properties?._bundleId ?? item?.properties?.bundleId;
        if (!bundleId || !/^([0-9a-f]{32}|[0-9A-Z]{26})$/.test(bundleId)) continue;
        if (!Object.hasOwn(bundleItemsMap, bundleId)) {
            bundleItemsMap[bundleId] = {
                bundleId,
                quantity: 1,
                price: (Number(item.price) * Number(item.quantity)) / 100,
                amount: (Number(item.price) * Number(item.quantity)) / 100,
                items: [item],
                discounted_price:
                    (Number(item.discounted_price) * Number(item.quantity)) /
                    100,
                isPresetBundleProduct: item?.properties?._isPresetBundleProduct,
                discountTitle: item?.discounts?.[0]?.title ?? "",
                final_line_price: Number(item.final_line_price) / 100,
            };
        } else {
            bundleItemsMap[bundleId].price +=
                (Number(item.price) * Number(item.quantity)) / 100;
            bundleItemsMap[bundleId].discounted_price +=
                (Number(item.discounted_price) * Number(item.quantity)) / 100;
            bundleItemsMap[bundleId].amount +=
                (Number(item.price) * Number(item.quantity)) / 100;
            bundleItemsMap[bundleId].final_line_price +=
                Number(item.final_line_price) / 100;
            bundleItemsMap[bundleId].items.push(item);
        }
    }
    return sortItemsByTitleLoop(Object.values(bundleItemsMap));
};

const sortItemsByTitleLoop = (bundles) => {
    return bundles.map((bundle) => {
        bundle.items.sort((a, b) => {
            let titleA = a.title.toUpperCase();
            let titleB = b.title.toUpperCase();
            if (titleA < titleB) {
                return -1;
            }
            if (titleA > titleB) {
                return 1;
            }
            return 0;
        });
        return bundle;
    });
};

const renderBundleItemsLoop = (bundleItems, clientId) => {
    let _parent = document.querySelector(`.${clientId}`);
    if (!_parent) {
        _parent = document.querySelector(`.${BUNDLE_CONTAINER_CLASS}`);
    }
    if (!_parent) {
        return;
    }

    for (let i = 0; i < bundleItems.length; ++i) {
        let bundleItem = bundleItems[i];
        const _bundleLink = bundleItem.isPresetBundleProduct
            ? `https://${window.Shopify.shop}/products/${bundleItem.productHandle}`
            : `${BUNDLE_LINK_PREFIX}/${bundleItem.loopBundleId}`;
        let _template = undefined;
        let hasTable = document.getElementsByTagName("table");

        if (
            bundleItem["isPresetBundleProduct"] &&
            window.location.pathname === "/cart"
        ) {
            _template = getPresetBundleCartTemplateLoop(
                bundleItem,
                i + 1,
                _bundleLink
            );
        } else if (
            bundleItem["isPresetBundleProduct"] &&
            window.location.pathname !== "/cart"
        ) {
            _template = getPresetBundleCartDrawerTemplateLoop(
                bundleItem,
                i + 1,
                _bundleLink
            );
        } else if (clientId.includes("drawer") && hasTable.length) {
            _template = getBundleCartDrawerTemplateLoop(
                bundleItem,
                i + 1,
                _bundleLink
            );
        } else if (hasTable.length) {
            _template = getBundleCartTableTemplateLoop(
                bundleItem,
                i + 1,
                _bundleLink
            );
        } else {
            _template = getBundleCartItemsDivTemplateLoop(
                bundleItem,
                i + 1,
                _bundleLink
            );
        }
        _parent.innerHTML = `${_template} ${_parent.innerHTML}`;
    }
};

async function getCartItemsLoop() {
    const url = `https://${Shopify.cdnHost.split("/cdn")[0]}/cart.json`;
    const res = await (await fetch(url)).json();
    return res?.items ?? [];
}

function setupMutationLoop(_bundleItems) {
    if (!_bundleItems?.length) return;

    if (window.location.pathname.includes("/a/loop_subscriptions/bundle")) {
        return;
    }

    let previousQuantity = window.Loop.bundleCartAllItems.reduce(
        (acc, curr) => acc + curr.quantity,
        0
    );
    let timeoutId;
    const handleChanges = async () => {
        const res = await getCartItemsLoop();
        let currenctQuantity = res.reduce(
            (acc, curr) => acc + curr.quantity,
            0
        );
        if (currenctQuantity !== previousQuantity) {
            window.location.reload();
        }
    };

    let targetNodes = document.querySelectorAll("form");
    const config = { childList: true, subtree: true };

    targetNodes.forEach((targetNode) => {
        const observer = new MutationObserver(() => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(handleChanges, 500);
        });
        observer.observe(targetNode, config);
    });
}

function setupMutationIfElementDelete() {
    let firstChange = true;
    let timeoutId;
    const handleChanges = () => {
        if (firstChange) {
            firstChange = false;
        } else {
            if (
                !window.location.pathname.includes(
                    "/a/loop_subscriptions/bundle"
                )
            ) {
                firstChange = true;
                window.location.reload();
            }
        }
    };

    let targetNode = document.querySelector(".cart-container");
    if (!targetNode) {
        targetNode = document.querySelector(".cart__blocks");
    }
    if (!targetNode) {
        return;
    }

    const observer = new MutationObserver(() => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(handleChanges, 1000);
    });
    const config = { childList: true, subtree: true };
    observer.observe(targetNode, config);
}

function setupMutationOldLoop() {
    var firstChange = true;
    let targetNode = null;
    let observerNode = null;
    targetNode = document.querySelectorAll(`[data-cart-subtotal]`);
    if ((targetNode && targetNode.length > 1) || !targetNode.length) {
        observerNode = document.querySelector(`.${CART_SUBTOTAL_CLASS}`);
    } else {
        observerNode = targetNode[0];
    }

    if (!observerNode) {
        return;
    }

    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
        if (firstChange) {
            firstChange = false;
            return;
        } else {
            firstChange = true;
            setTimeout(window.location.reload(), 1000);
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(observerNode, config);
}

const initLoopBundle = async (clientId) => {
    console.log(`Loop Bundle Initialized for ${clientId}`);
    const _cartItems = window.Loop.bundleCartAllItems;
    const _bundleItems = getBundleItemsLoop(_cartItems);
    await addExtraDetailsToBundleItemsLoop(_bundleItems);
    setupMutationLoop(_bundleItems);
    renderBundleItemsLoop(_bundleItems, clientId);
};
